var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellWifiSignal2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1727 7.80135C18.6317 8.34611 18.0823 8.88805 17.5244 9.4441C15.4668 7.41748 12.9803 6.359 10.0873 6.359C7.1999 6.359 4.71058 7.39772 2.61652 9.47233C2.07549 8.91628 1.54006 8.36587 0.999023 7.81546C5.93281 2.70092 14.267 2.76019 19.1727 7.80135Z",
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23633 11.1274C7.54101 7.77715 12.8722 7.96834 15.9104 11.1246C15.8821 11.1531 15.8622 11.1902 15.8311 11.2216C15.3351 11.721 14.8391 12.2204 14.3544 12.7255C14.2808 12.7997 14.2382 12.7911 14.1731 12.7255C13.3653 11.9122 12.3932 11.4014 11.2765 11.1845C10.5396 11.0418 9.79988 11.0332 9.06015 11.156C8.01433 11.33 7.09037 11.7638 6.28263 12.4458C6.14942 12.5571 6.02755 12.6856 5.92268 12.7797C5.35584 12.2204 4.80034 11.6782 4.242 11.1274H4.23633Z",
    fill: "#008514"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.047 17.0003C9.64815 16.5987 9.25785 16.1942 8.86471 15.7926C8.45733 15.3824 8.05564 14.9722 7.64541 14.5649C7.56279 14.4817 7.55139 14.4301 7.64541 14.3469C8.99861 13.0991 11.1039 13.0963 12.4514 14.3326C12.5511 14.4215 12.5625 14.4674 12.4571 14.5735C11.6708 15.3652 10.8931 16.1598 10.1097 16.9544C10.1011 16.963 10.0869 16.9716 10.0498 16.9974L10.047 17.0003Z",
    fill: "#008514"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellWifiSignal2);
export default __webpack_public_path__ + "static/media/icn_table_cell_wifi_signal_2.b65bf00dad38e5894fce91a3cec16e0c.svg";
export { ForwardRef as ReactComponent };